import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import PartnerQualityFeedbackSearch from '@/src/javascripts/partner/quality_feedbacks/PartnerQualityFeedbackSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const partnerQualityFeedbackIndex = document.querySelector('#partner-quality-feedback-index')
  if (partnerQualityFeedbackIndex && !partnerQualityFeedbackIndex.__vue_app__) {
    createApp({ components: { BaseAlert, PartnerQualityFeedbackSearch } }).mount(partnerQualityFeedbackIndex)
  }
})
